export const expertiseSelectOptions = [
  { name: 'Please select', value: '' },
  { name: 'Expertise in the industry', value: 'expertise-in-industry' },
  { name: 'Contacts in the industry', value: 'contacts-in-industry' },
  { name: 'Other (please specify)', value: 'looking-for-other-support' },
  { name: "Doesn't matter", value: 'not-looking-for-specific-support' },
];

export const updateFrequencySelectOptions = [
  { name: 'Please select', value: '' },
  {
    name: 'Monthly (For fast-growing startups)',
    value: 'monthly-fast-growing-startups',
  },
  { name: 'Every 3 months', value: 'every-3-months' },
  { name: 'Every 6 months', value: 'every-6-months' },
  {
    name: 'Annually (on the date you registered)',
    value: 'annually',
  },
];
